"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var snapTransform = {
  "38": "translate(8.0, 8.0) scale(0.567)",
  "70": "translate(8.0, 8.0) scale(0.623)",
  "90": "translate(8.0, 8.0) scale(0.76)",
  "120": "translate(8.0, 8.0)"
};
var propTypes = {
  /** Size of chip  */
  size: (0, _propTypes.oneOf)(["38", "70", "90", "120"]).isRequired
};

var SnapdragonLogo = function SnapdragonLogo(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd",
    id: "SnapdragonLogo",
    strokeWidth: "1",
    transform: snapTransform[size]
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(0.680723, 0.00)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.4412378,26.0002459 C28.4412378,20.9336458 25.5263823,17.6959158 22.6160651,16.198945 C18.3526976,14.0055335 12.9929124,12.7053284 12.9929124,7.15754277 C12.9929124,3.01679103 15.9547378,0.0794595195 19.2131313,0.00344682202 C19.1187378,0.00207722387 19.0245711,2.28266359e-05 18.9299506,2.28266359e-05 C18.7388944,2.28266359e-05 18.5496534,0.00709908376 18.3599586,0.0128057427 C13.2888,0.236278508 7.56028996,3.49706344 6.42643253,8.71660201 C6.38513534,8.90629135 6.11511526,8.90880228 6.07586024,8.71888467 C5.816051,7.46615889 5.8693743,6.10614793 6.2439988,4.90478208 C5.16732209,5.88267516 4.20341847,6.98314728 3.37270964,8.18405659 C2.94952691,8.85173569 2.59645863,9.56095927 2.34708715,10.3165209 C1.61599076,12.5316177 1.89644859,15.2260738 3.43896667,17.03965 C4.88913333,18.7441149 7.2194747,19.3768692 9.07421767,20.5163749 C10.9244225,21.6533696 12.5502157,23.1651777 13.3021876,25.2586085 C14.1054406,27.4942492 13.9536394,30.0111141 13.0966092,32.2168519 C13.021049,32.4101935 12.7369606,32.3439963 12.7494406,32.137187 C12.940043,28.9378057 11.3299064,25.9308529 8.34198675,24.5363737 C6.77155904,23.8031822 5.03707711,23.5233276 3.4695992,22.7791793 C2.04734217,22.1041957 0.220281928,20.7893815 -4.53815261e-05,19.083547 C0.01992249,28.8962612 7.41711124,36.9657052 16.9086574,37.9794361 C23.7730671,38.179854 28.4412378,32.8475519 28.4412378,26.0002459",
    fill: "#E04F4F",
    id: "Fill-1"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(13.614458, 0.00)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.10712399,0 C2.90797393,0.0760126975 0,3.0133442 0,7.15386769 C0,12.7018815 5.2623345,14.0020867 9.4481862,16.1952699 C12.3055886,17.6924689 15.1674467,20.9299707 15.1674467,25.9967991 C15.1674467,32.844105 10.5841518,38.1764072 3.84454962,37.9759893 C4.49663264,38.0467519 5.15851807,38.0841876 5.829092,38.0841876 C16.0939972,38.0841876 24.4155746,29.5579825 24.4155746,19.0403818 C24.4155746,8.61773985 16.2437067,0.152481928 6.10712399,0",
    fill: "#FFFFFF",
    id: "Fill-1"
  })));
};

SnapdragonLogo.propTypes = propTypes;
SnapdragonLogo.displayName = "Modules.SnapdragonLogo";
var _default = SnapdragonLogo;
exports["default"] = _default;